// MastiBazaar — async reviews data layer (backed by FastAPI).
import { apiCreateReview, apiListReviews } from "@/lib/api";

const REVIEWS_EVENT = "mb-reviews-change";
export const REVIEWS_CHANGE_EVENT = REVIEWS_EVENT;

export const getReviewsForProduct = async (productId) => {
  if (!productId) return [];
  const list = await apiListReviews(productId);
  return Array.isArray(list) ? list : [];
};

export const getReviewStats = async (productId) => {
  const list = await getReviewsForProduct(productId);
  if (list.length === 0) return { count: 0, avg: 0 };
  const sum = list.reduce((acc, r) => acc + (Number(r.rating) || 0), 0);
  return { count: list.length, avg: sum / list.length };
};

export const addReview = async ({ productId, name, comment, rating }) => {
  if (!productId) return null;
  const r = await apiCreateReview({
    productId,
    name: String(name || "Anonymous").trim() || "Anonymous",
    comment: String(comment || "").trim(),
    rating: Math.max(1, Math.min(5, Math.round(Number(rating) || 0))),
  });
  try {
    window.dispatchEvent(new Event(REVIEWS_EVENT));
  } catch {
    /* noop */
  }
  return r;
};
